<template>
  <div>
    <v-card-title>Create / Edit Our Service</v-card-title>
    <v-divider></v-divider>
<!--    <v-row justify="center">-->
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Title TH :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <input-text-field :model="form.title_th" @update="updateTitleTH" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Title EN :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <input-text-field :model="form.title_en" @update="updateTitleEN" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Detail TH* :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <input-editor :model="form.detail_th" @update="updateDetailTH" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3" class="label">
            <label>Detail EN* :</label>
          </v-col>
          <v-col cols="12" sm="8">
            <input-editor :model="form.detail_en" @update="updateDetailEN" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Image Cover:</label>
            <div style="color: #2E8037; font-size: 12px">
              *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
            </div>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-image-upload
                    id="input3"
                    height="200px"
                    width="200px"
                    :error-size="'500'"
                    :model="form.image_show"
                    @update="updateImage"
                    col="col-6"
            />
          </v-col>
        </div>
      <v-divider></v-divider>
      <div class="row text-right">
        <v-spacer></v-spacer>
        <cancel-button @click.native="cancelData" />
        <save-button @click.native="submitData" />
      </div>
      <br />
<!--  </v-row>-->
  </div>
</template>

<script>
import InputEditor from "../../components/Input/InputEditor";
import InputTextField from "../../components/Input/InputTextField";
import SelectOption from "../../components/Input/selectOption";
import { mapState } from "vuex";
import SaveButton from "../../components/Button/SaveButton";
import CancelButton from "../../components/Button/CancelButton";
import Swal from "sweetalert";
import InputImageUpload from "../../components/Input/InputImageUpload";
export default {
  name: "CreateOurServiceDetail",
  components: {InputImageUpload, CancelButton, SaveButton, SelectOption, InputTextField, InputEditor },
  props: {
    services: Array
  },
  data() {
    return {
      optionMenu: [],
      optionService: [],
      image_show: ''
    };
  },
  computed: {
    ...mapState({
      form: state => {
        return state.OurService.detail;
      }
    })
  },
  methods: {
    submitData() {
      if (this.validateSave) {
        this.$store
          .dispatch("OurService/saveOurServiceDetail", {
            id: this.form.id,
            data: this.form
          })
          .then(res => {
            if (res.response_code == 200) {
              this.$emit("update", res.result);
              // this.$router.push("/our-service/edit");
              // this.$router.push({ path: '/our-service/edit', params: this.form});
            }
      else {
              Swal(res.response_msg);
            }
          })
          .catch(() => {
            Swal('','Cannot save our service detail','error');
          });
      }
    },
    cancelData() {
      this.$emit("update", false);
      // this.$router.push("/our-service/edit");
    },
    validateSave() {
      if (!this.form.detail_th) {
        Swal('','Please insert detail TH !','error');
        return false;
      } else if (!this.form.detail_en) {
        Swal('','Please insert detail EN !','error');
        return false;
      } else {
        return true;
      }
    },
    deleteSubMenu() {
      this.$store
        .dispatch("OurService/deleteOurServiceDetail", this.form.sub_menu_id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToSubMenuTable();
          }
        })
        .catch(() => {
          Swal('','Cannot delete our service data','error');
        });
    },
    updateTitleTH(val) {
      this.form.title_th = val;
    },
    updateTitleEN(val) {
      this.form.title_en = val;
    },
    updateDetailTH(val) {
      this.form.detail_th = val;
    },
    updateDetailEN(val) {
      this.form.detail_en = val;
    },
    updateImage(val) {
      this.form.image = val.imagePath;
      this.form.image_show = val.fullImagePath;
      console.log('image', val)
    },
  }
};
</script>

<style scoped></style>
